<body class="back">
 
  <div class="vegas-timer vegas-timer-running">
    <div class="vegas-timer-progress" style="transition-duration: 4900ms"></div>
  </div>
  <div
    id="mCSB_1"
    class="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside"
    tabindex="0"
  >
    <div
      id="mCSB_1_container"
      class="mCSB_container"
      style="position: relative; top: 0; left: 0"
      dir="ltr"
    >
     
      <div
        class="global-overlay"
        style="opacity: 1; transform: translateX(100%)"
      >
        <div class="overlay skew-part">
          <div id="stars"></div>
          <div id="stars2"></div>
          <div id="stars3"></div>
        </div>
      </div>
  
      <section>
        <div class="top_bg">
          <div class="container">
            <div class="row">
              <div class="col-lg-6">
                <img
                  src="{{ onPassiveBaseUrl }}onpassive(nov-28)/images/logo.png"
                  alt="logo"
                  class="brand-logo mCS_img_loaded"
                />
              </div>
              <div class="col-lg-6 text-right social_image">
                <a
                  href="https://www.facebook.com/ONPASSIVE/ONPASSIVE"
                  target="_blank"
                  rel="noopener"
                  ><img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(nov-28)/images/img/fb.png"
                    alt="facebook"
                /></a>
                <a
                  href="https://twitter.com/ONPASSIVE"
                  target="_blank"
                  rel="noopener"
                  ><img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(nov-28)/images/img/twitter.png"
                    alt="twitter"
                /></a>
                <a
                  href="https://www.linkedin.com/company/onpassiveofficial/company/onpassiveofficial"
                  target="_blank"
                  rel="noopener"
                  ><img
                    src="{{ onPassiveBaseUrl }}onpassive(nov-30)/images/in.png"
                    title="Linkedin"
                    alt="LinkedIn"
                /></a>
                <a
                  href="https://www.youtube.com/c/ONPASSIVEc/ONPASSIVE"
                  target="_blank"
                  rel="noopener"
                  ><img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(nov-28)/images/img/youtube.png"
                    alt="YouTube"
                /></a>
                <a
                  href="https://www.instagram.com/ONPASSIVE/"
                  target="_blank"
                  rel="noopener"
                  ><img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(nov-28)/images/img/insta.png"
                    alt="Instagram"
                /></a>
                <a
                  href="https://onpassive.com/blog/"
                  target="_blank"
                  rel="noopener"
                  ><img
                    src="{{
                      onPassiveBaseUrl
                    }}onpassive(nov-30)/images/blog.png"
                    alt="blog"
                /></a>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <!--<div class="content">-->
              <h1 class="text-intro animated-middle fadeInUp head">
                Multilevel Marketing System
              </h1>
              <h2 class="text-intro animated-middle fadeInUp para">
                Life is hard, not impossible. The one who believes in this is
                the one who has what it takes to get their life on track. At
                ONPASSIVE, you can kick start your life. Implementing the
                futuristic technology - AI in the business, we are all set to
                change the world of marketing. The secret of getting ahead is
                getting started. Start now and don't look behind.
              </h2>
              <nav>
                <ul>
                  <li>
                    <a
                      href="/registration/user?reg={{ userId }}"
                      name="regform"
                      id="open-more-info"
                      data-target="right-side"
                      class="light-btn text-intro animated-middle fadeInUp"
                      target="_blank"
                      rel="noopener"
                      >Become A Founder Now</a
                    >
                  </li>
               
                </ul>
              </nav>
            
            </div>
            <div class="col-lg-6">
              <div class="vd">
                <video
                  id="my-video"
                  class="
                    video-js video-size
                    w-100
                    h-auto
                    my-video-dimensions
                    shadow
                  "
                  controls
                  preload="auto"
                  poster="{{ myLinksS3URL }}images/Image0231.png"
                  data-setup="{}"
                  autoplay="true"
                  muted
                >
                  <source
                    src="{{
                      myLinksS3URL
                    }}videos/Onpassive_launching_page_video.mp4"
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
          </div>
        </div>
      </section> 
    </div>
  </div>
</body>
